import { FC, useCallback } from 'react';

import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import {
  useSearchParamState,
  serializationOptionsForStringValue,
} from 'utils/hooks/useSearchParamState';

import { DEFAULT_SORT_FIELD, SORT_BY, SORT_DIRECTION } from './constants';
import { SortingContext, SortingContextState } from './context';

type Props = {
  defaultSortField?: string;
  defaultSortDirection?: SORT_DIRECTIONS;
  namespace?: string;
};

export const SortingContextProvider: FC<React.PropsWithChildren<Props>> = ({
  children,
  defaultSortField = DEFAULT_SORT_FIELD,
  defaultSortDirection = SORT_DIRECTIONS.DESCENDING,
  namespace,
}) => {
  const [sortBy, setSortBy] = useSearchParamState({
    searchParamKey: namespace ? `${namespace}.${SORT_BY}` : SORT_BY,
    stateValueWhenSearchParamIsUnset: defaultSortField,
    ...serializationOptionsForStringValue,
  });
  const [sortDirection, setActualSortDirection] = useSearchParamState({
    searchParamKey: namespace ? `${namespace}.${SORT_DIRECTION}` : SORT_DIRECTION,
    stateValueWhenSearchParamIsUnset: defaultSortDirection,
    ...serializationOptionsForStringValue,
  });

  const setSortDirection = useCallback((dir: SORT_DIRECTIONS) => {
    const target =
      dir === SORT_DIRECTIONS.ASCENDING ? SORT_DIRECTIONS.ASCENDING : SORT_DIRECTIONS.DESCENDING;
    setActualSortDirection(target);
  }, []);

  const context: SortingContextState = {
    sortBy,
    setSortBy,
    sortDirection: sortDirection as SORT_DIRECTIONS,
    setSortDirection,
  };

  return <SortingContext.Provider value={context}>{children}</SortingContext.Provider>;
};
